module.exports = __webpack_public_path__ + "static/media/waschbecken_active_start.e5e7b1e1.jpg";